module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secondary-header"
  }, [_c('div', {
    class: _vm.computedSecondaryHeaderClass
  }, [_c('div', {
    staticClass: "secondary-header--left"
  }, [(!_vm.compressed) ? _c('div', [(_vm.breadcrumbs.length > 0) ? _c('span', {
    staticClass: "secondary-header--breadcrumbs"
  }, _vm._l((_vm.breadcrumbs), function(crumb, idx) {
    return _c('span', {
      staticClass: "back-icon"
    }, [_c('router-link', {
      attrs: {
        "to": crumb.link
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t(crumb.label)) + " ")])])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.level == 3 && !_vm.projectLeadEdit()) ? _c('div', {
    staticClass: "secondary-header--subtitle",
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.subtitle.link
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.back")) + " ")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.projectLeadEdit()) ? _c('div', [_c('div', {
    staticClass: "secondary-header--subtitle"
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'projects'
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.all_projects")) + " ")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.getProjectPathWithQueries()
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.getProjectName()) + " ")])])], 1)])]) : (_vm.projectLeads()) ? _c('div', {
    staticClass: "secondary-header--subtitle",
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "back-icon"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.subtitle.link
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("ui.breadcrump.all_projects")) + " ")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space-between"
  }, [_c('div', {
    staticClass: "secondary-header--title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "secondary-header--right"
  }, [(!_vm.compressed) ? _c('add-button') : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('folded-navigation', {
    ref: "foldedNavigation",
    attrs: {
      "items": _vm.headerTabs
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65eb306e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/SecondaryHeader.vue
// module id = 1927
// module chunks = 0